// hooks
import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { TutorialVideos } from '@/vue3/api/models';
import { VideoCategory, VideoItem } from '@/vue3/api/models/tutorialVideosModels';

export const useTutorialVideoService = () => {
    // hooks
    const { apiUrl, bunnyNetBaseUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getVideosDescription = async (): Promise<TutorialVideos[]> => {
        const res = await axios.get(`${apiUrl}/tutorial-video`);
        return res.data;
    };
    const getVideoCategories = async (): Promise<VideoCategory[]> => {
        try {
            const videos = await getVideosDescription();
            
            // categories
            const categories: VideoCategory[] = [
                { id: 'getting-started', title: 'GETTING STARTED', order: 1, videos: [] },
                { id: 'geo-records', title: 'GEO RECORDS', order: 2, videos: [] },
                { id: 'course-manager', title: 'COURSE MANAGER', order: 3, videos: [] },
                { id: 'comparison-measure', title: 'COMPARISON + MEASURE', order: 4, videos: [] },
                { id: 'pinzone', title: 'PINZONE', order: 5, videos: [] }
            ];
            
         
            for (const video of videos) {
                const videoIdNum = parseInt(video.videoId);
                let categoryId: string;
                
                if (videoIdNum >= 100 && videoIdNum < 200) categoryId = 'getting-started';
                else if (videoIdNum >= 200 && videoIdNum < 300) categoryId = 'geo-records';
                else if (videoIdNum >= 300 && videoIdNum < 400) categoryId = 'course-manager';
                else if (videoIdNum >= 400 && videoIdNum < 500) categoryId = 'comparison-measure';
                else if (videoIdNum >= 500 && videoIdNum < 600) categoryId = 'pinzone';
                else continue; // skip vids that dont fit in any category
                
                const category = categories.find(c => c.id === categoryId);
                if (category) {
                    category.videos.push({
                        id: video.id,
                        videoId: video.videoId,
                        title: video.videoDescription,
                        priority: video.videoPriority,
                        filename: video.videoFilename 
                    });
                }
            }
            // sort for priortity
            for (const category of categories) {
                category.videos.sort((a, b) => a.priority - b.priority);
            }
            
            return categories.filter(category => category.videos.length > 0);
            
        } catch (error) {
            console.error('Error getting video categories:', error);
            return [];
        }
    };

    const getVideoURL = (video: VideoItem | number): string => {
        if (typeof video === 'object') {
            if (video.filename) {
                return `${bunnyNetBaseUrl}/tutorial_videos/new/${video.filename}.mp4`;
            } else {
                // fall back
                return `${bunnyNetBaseUrl}/tutorial_videos/${video.videoId}.mp4`;
            }
        } 
        // legacy back compat
        return `${bunnyNetBaseUrl}/tutorial_videos/${video}.mp4`;
    };

    const checkVideoExists = async (url: string): Promise<boolean> => {
        try {
            const response = await fetch(url, { method: 'HEAD' });
            return response.ok;
        } catch (error) {
            return false;
        }
    };

    return { getVideosDescription, getVideoCategories, getVideoURL, checkVideoExists };
};